import { render, staticRenderFns } from "./OrderSuccess.vue?vue&type=template&id=0468f20e&scoped=true"
import script from "./OrderSuccess.vue?vue&type=script&lang=js"
export * from "./OrderSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0468f20e",
  null
  
)

export default component.exports